import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialFdTenureState: IFdTenureState = {
  data: {
    fdTenure: [],
    meta: {},
  },
  deleteSuccess: false,
  loading: false,
  success: false,
}

export interface IFdTenureState {
  data?: {
    fdTenure?: []
    meta?: {[key: string]: number}
  }
  activateSuccess?: boolean
  deactivateSuccess?: boolean
  singleActivateSuccess?: boolean
  singleDeactivateSuccess?: boolean
  deleteSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: IFdTenureState = initialFdTenureState,
  action: ActionWithPayload<IFdTenureState>
) => {
  switch (action.type) {
    case actionTypes.GET_FD_TENURE_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_FD_TENURE_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_FD_TENURE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_FD_TENURE_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_FD_TENURE_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_FD_TENURE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_FD_TENURE_RESET: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    case actionTypes.UPDATE_FD_TENURE_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_FD_TENURE_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_FD_TENURE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.DELETE_FD_TENURE_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_FD_TENURE_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_FD_TENURE_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    case actionTypes.SINGLE_ACTIVATE_FD_TENURE_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_ACTIVATE_FD_TENURE_SUCCESS: {
      return {...state, activateSuccess: true, loading: false}
    }
    case actionTypes.SINGLE_ACTIVATE_FD_TENURE_FINISH: {
      return {...state, activateSuccess: false, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_FD_TENURE_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_DEACTIVATE_FD_TENURE_SUCCESS: {
      return {...state, deactivateSuccess: true, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_FD_TENURE_FINISH: {
      return {...state, deactivateSuccess: false, loading: false}
    }

    default:
      return state
  }
}
